import dayjs, { Dayjs } from 'dayjs';
import { useSelector } from 'react-redux';
import { useReportPeriod } from '@/store/slices/reportFiltersSlice';
import { reportsService } from '@/store/services/reports';
import { PeriodKey, periodMapper } from './SharedComponents/DatesFilters';

export interface DefaultReportDates {
  defaultFromDate: Dayjs;
  defaultToDate: Dayjs;
  defaultFromDateStr: string;
  defaultToDateStr: string;
}

export function useDefaultReportDates(): DefaultReportDates {
  const period = useReportPeriod();

  const reportPeriodsResult = useSelector(
    reportsService.endpoints.getReportPeriodsLK.select(undefined)
  );
  const periodData = reportPeriodsResult?.data;
  const periodCode = (
    !!period ? periodData?.find((i) => i.id === period)?.code : 'THREE_MONTHS'
  ) as PeriodKey | undefined;

  const defaultFromDate = dayjs().subtract(
    periodMapper[periodCode as PeriodKey],
    'day'
  );
  const defaultToDate = dayjs();

  return {
    defaultFromDate,
    defaultToDate,
    defaultFromDateStr: defaultFromDate.format('YYYY-MM-DD'),
    defaultToDateStr: defaultToDate.format('YYYY-MM-DD'),
  };
}

export default useDefaultReportDates;
